{
  "common": {
    "cancel": "Annulla",
    "save": "Salva",
    "delete": "Elimina",
    "done": "Fatto",
    "edit": "Modifica",
    "search": "Cerca",
    "loading": "Caricamento…",
    "yes": "Sì",
    "no": "No",
    "settings": "Impostazioni",
    "back": "Indietro",
    "close": "Chiudi",
    "open": "Apri",
    "copy": "Copia",
    "restore": "Ripristina",
    "untitled": "Senza titolo",
    "create": "Crea",
    "revoke": "Revoca",
    "never": "Mai",
    "tryAgain": "Riprova",
    "reload": "Ricarica",
    "update": "Aggiorna",
    "insert": "Inserisci",
    "loadingShort": "Caricamento",
    "unknown": "Sconosciuto",
    "sampleSentence": "La volpe marrone veloce"
  },
  "sidebar": {
    "views": "Viste",
    "tags": "Tag",
    "edit": "Modifica",
    "done": "Fatto",
    "account": "Account",
    "newNote": "Nuova nota",
    "editTag": "Modifica tag",
    "tagOptions": "Opzioni tag",
    "reorder": "Riordina {{label}}",
    "showView": "Mostra {{label}}",
    "hideView": "Nascondi {{label}}",
    "editViews": "Modifica viste",
    "doneEditingViews": "Termina modifica",
    "samplePeep": "Caliu è…",
    "sampleQuiet": "Un luogo tranquillo dove i tuoi pensieri vivono e respirano."
  },
  "views": {
    "all": "Tutte le note",
    "today": "Oggi",
    "todo": "Da fare",
    "pinned": "Fissate",
    "untagged": "Senza tag",
    "thisWeek": "Questa settimana",
    "shared": "Condivise da me",
    "sharedWithMe": "Condivise con me",
    "attachments": "Allegati",
    "trash": "Cestino",
    "archive": "Archiviate"
  },
  "noteList": {
    "empty": "Ancora nessuna nota",
    "emptySubtitle": "Crea la prima per iniziare.",
    "untitled": "Senza titolo",
    "selectNote": "Seleziona una nota",
    "selectNoteHint": "Scegli una nota dall'elenco o creane una nuova.",
    "selectRestoreOrDelete": "Seleziona una nota per ripristinarla o eliminarla definitivamente",
    "selectSharedToView": "Seleziona una nota condivisa per visualizzarla",
    "searchPlaceholder": "Cerca note…",
    "selectNotes": "Seleziona note",
    "openSidebar": "Apri barra laterale",
    "cancelSelection": "Annulla selezione",
    "clearSelection": "Cancella selezione",
    "emptyTrash": "Svuota cestino",
    "newNote": "Nuova nota",
    "noteCount_one": "{{count}} nota",
    "noteCount_other": "{{count}} note",
    "sortBy": "Ordina per",
    "preview": "Anteprima",
    "modificationDate": "Data di modifica",
    "creationDate": "Data di creazione",
    "title": "Titolo",
    "manual": "Manuale",
    "newestOnTop": "Più recenti in cima",
    "small": "Piccola",
    "medium": "Media",
    "large": "Grande",
    "empty_pinned": "Ancora niente di fissato",
    "empty_pinned_subtitle": "Fissa una nota per trovarla rapidamente qui.",
    "empty_today": "Niente modificato oggi",
    "empty_today_subtitle": "Le note che modifichi oggi appariranno qui.",
    "empty_todo": "Ancora nessuna attività",
    "empty_todo_subtitle": "Le note con attività aperte appariranno qui.",
    "empty_untagged": "Tutto ha un tag",
    "empty_untagged_subtitle": "Le note senza tag appariranno qui.",
    "empty_thisWeek": "Niente questa settimana",
    "empty_thisWeek_subtitle": "Le note modificate negli ultimi 7 giorni appariranno qui.",
    "empty_shared": "Nessuna nota condivisa",
    "empty_shared_subtitle": "Le note che condividi appariranno qui.",
    "empty_attachments": "Ancora nessun allegato",
    "empty_attachments_subtitle": "Le note con immagini o file appariranno qui.",
    "justNow": "Adesso",
    "minutesAgo": "{{count}} min fa",
    "today": "Oggi",
    "yesterday": "Ieri",
    "deletedOn": "Eliminata il {{date}}",
    "newNoteShortcut": "Nuova nota ({{shortcut}})",
    "noContent": "Nessun contenuto",
    "selectUnarchiveOrDelete": "Seleziona una nota per rimuoverla dall'archivio o eliminarla",
    "view": "Vista",
    "density": "Densità",
    "exportAll": "Esporta tutto"
  },
  "editor": {
    "attachmentTooLarge": "Questo file è troppo grande da allegare. Il limite è 100 MB.",
    "placeholder": "Inizia a scrivere…",
    "noMatchingCommands": "Nessun comando corrispondente",
    "newNote": "nuova nota",
    "noResults": "Nessun risultato",
    "foldSection": "Comprimi sezione",
    "unfoldSection": "Espandi sezione",
    "dragSection": "Sposta sezione",
    "presenceLabel": "Presenti anche: {{names}}"
  },
  "noteActions": {
    "pin": "Fissa",
    "unpin": "Rimuovi fissaggio",
    "pinToTop": "Fissa in alto",
    "makeReadOnly": "Rendi di sola lettura",
    "makeEditable": "Rendi modificabile",
    "readOnlyNote": "Nota di sola lettura",
    "shareNote": "Condividi nota",
    "share": "Condividi",
    "publiclyShared": "Condivisa pubblicamente",
    "privateNote": "Nota privata",
    "linkCreated": "Link creato",
    "linkCreatedAndCopied": "Link creato e copiato",
    "linkRevoked": "Link di condivisione revocato",
    "failedToCreateShareLink": "Impossibile creare il link di condivisione",
    "failedToRevokeShareLink": "Impossibile revocare il link di condivisione",
    "thisNoteIsPrivate": "Questa nota è privata.",
    "createPublicLink": "Crea link pubblico",
    "creatingLink": "Creazione link…",
    "revokeLink": "Revoca link",
    "revokingLink": "Revoca in corso…",
    "copyLink": "Copia link",
    "copyNoteId": "Copia ID della nota",
    "noteIdCopied": "ID della nota copiato",
    "exportAs": "Esporta come",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Testo semplice",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Esportazione non riuscita",
    "viewHistory": "Visualizza cronologia",
    "duplicate": "Duplica",
    "duplicateFailed": "Impossibile duplicare la nota",
    "select": "Seleziona",
    "delete": "Elimina",
    "moveToTrash": "Sposta nel cestino",
    "archive": "Archivia",
    "unarchive": "Rimuovi dall'archivio",
    "tags": "Tag",
    "addTag": "Aggiungi tag",
    "noTagsYet": "Ancora nessun tag",
    "addTagFailed": "Impossibile aggiungere il tag",
    "removeTagFailed": "Impossibile rimuovere il tag"
  },
  "userMenu": {
    "theme": "Tema",
    "typography": "Tipografia",
    "language": "Lingua",
    "apiKeys": "Chiavi API",
    "devices": "Dispositivi",
    "connectedApps": "App connesse",
    "help": "Aiuto",
    "logOut": "Esci",
    "defaultUserName": "Utente Caliu",
    "editName": "Modifica nome",
    "nameLabel": "Nome",
    "namePlaceholder": "Il tuo nome",
    "upgradeToPro": "Passa a Caliu Pro",
    "replayOnboarding": "Rivedi l'introduzione",
    "logOutTitle": "Vuoi uscire?",
    "logOutBody": "Le tue note restano su questo dispositivo e puoi continuare a leggerle e scriverle. Accedi di nuovo per sincronizzare.",
    "logOutPending_one": "{{count}} modifica non è ancora sincronizzata. Resta su questo dispositivo finché non accedi di nuovo.",
    "logOutPending_other": "{{count}} modifiche non sono ancora sincronizzate. Restano su questo dispositivo finché non accedi di nuovo.",
    "logOutKeep": "Esci",
    "logOutAndRemove": "Esci ed elimina le note"
  },
  "help": {
    "title": "Centro assistenza",
    "searchPlaceholder": "Cerca articoli di aiuto",
    "noResults": "Nessun articolo corrisponde alla tua ricerca.",
    "offline": "L'aiuto non è disponibile offline. Verrà caricato la prossima volta che sarai connesso."
  },
  "fonts": {
    "uiFont": "Font dell'interfaccia",
    "body": "Corpo",
    "headings": "Titoli",
    "code": "Codice",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Interfaccia",
    "reset": "Ripristina"
  },
  "themes": {
    "light": "Chiaro",
    "dark": "Scuro",
    "system": "Sistema"
  },
  "languages": {
    "systemHint": "Rilevata dal tuo dispositivo",
    "names": {
      "en": "Inglese",
      "es": "Spagnolo",
      "ca": "Catalano",
      "fr": "Francese",
      "de": "Tedesco",
      "it": "Italiano",
      "pt": "Portoghese",
      "nl": "Olandese",
      "ja": "Giapponese",
      "zh-CN": "Cinese (semplificato)",
      "ko": "Coreano",
      "zh-TW": "Cinese (tradizionale)",
      "ru": "Russo"
    }
  },
  "bulkActions": {
    "pinSelected": "Fissa selezionate",
    "unpinSelected": "Rimuovi fissaggio dalle selezionate",
    "pin": "Fissa",
    "addTag": "Aggiungi tag",
    "filterTags": "Filtra tag…",
    "noTagsFound": "Nessun tag trovato",
    "exportSelected": "Esporta selezionate",
    "restoreSelected": "Ripristina selezionate",
    "deletePermanently": "Elimina definitivamente",
    "moveToTrash": "Sposta nel cestino",
    "archiveSelected": "Archivia selezionate",
    "unarchiveSelected": "Rimuovi selezionate dall'archivio",
    "exportingTitle": "Esportazione delle tue note",
    "exportingBody": "Può richiedere un momento. Tieni questa scheda aperta fino al termine.",
    "exportingProgress": "{{done}} di {{total}}"
  },
  "commandPalette": {
    "placeholder": "Cerca note, tag, comandi…",
    "noResults": "Nessun risultato per «{{query}}»",
    "currentNote": "Nota corrente",
    "navigation": "Navigazione",
    "notes": "Note",
    "tags": "Tag",
    "newNote": "Nuova nota",
    "allNotes": "Tutte le note",
    "todaysNotes": "Note di oggi",
    "todo": "Da fare",
    "pinnedNotes": "Note fissate",
    "trash": "Cestino",
    "importNotes": "Importa note",
    "changeTheme": "Cambia tema",
    "keyboardShortcuts": "Scorciatoie da tastiera",
    "pinNote": "Fissa nota",
    "unpinNote": "Rimuovi fissaggio dalla nota",
    "restoreNote": "Ripristina nota",
    "copyShareLink": "Copia link di condivisione",
    "makePrivate": "Rendi privata",
    "toggleFullscreen": "Schermo intero",
    "noteInfo": "Info nota",
    "moveToTrash": "Sposta nel cestino",
    "archiveNote": "Archivia nota",
    "unarchiveNote": "Rimuovi nota dall'archivio",
    "archive": "Archiviate"
  },
  "noteHistory": {
    "title": "Cronologia nota",
    "requiresConnection": "La cronologia richiede una connessione.",
    "reconnect": "Riconnettiti a Internet e riprova.",
    "noHistory": "Nessuna cronologia per questa nota.",
    "windowMerged": "Le modifiche entro 5 minuti vengono unite in una sola voce.",
    "selectVersion": "Seleziona una versione per l'anteprima",
    "encrypted": "Versione cifrata",
    "encryptedHint": "Questa versione è stata salvata con crittografia end-to-end. Apri la nota per vedere il contenuto attuale.",
    "restoreVersion": "Ripristinare questa versione?",
    "restoreVersionHint": "Questo sostituirà il contenuto attuale della nota con la versione del {{date}}.",
    "current": "Attuale",
    "created": "Creata",
    "trashed": "Cestinata",
    "restored": "Ripristinata",
    "edited": "Modificata"
  },
  "apiKeys": {
    "title": "Chiavi API",
    "empty": "Ancora nessuna chiave API.",
    "emptyHint": "Creane una per iniziare a usare l'API.",
    "created": "Creata il {{date}}",
    "lastUsed": "Ultimo uso: {{date}}",
    "revokeKey": "Revoca chiave",
    "viewApiDocs": "Documentazione API",
    "newApiKey": "Nuova chiave API",
    "apiKeyCreated": "Chiave API creata",
    "createApiKey": "Crea chiave API",
    "copyHint": "Copia questa chiave ora. Non potrai più vederla.",
    "copyToClipboard": "Copia negli appunti",
    "keyName": "Nome chiave",
    "keyNamePlaceholder": "es. Il mio script, Integrazione Zapier",
    "createKey": "Crea chiave",
    "revokeKeyTitle": "Revoca chiave API",
    "revokeKeyHint": "Questo revocherà definitivamente questa chiave API. Tutte le applicazioni che la usano perderanno l'accesso immediatamente.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "App connesse",
    "empty": "Ancora nessuna app connessa.",
    "emptyHint": "Collega Claude, ChatGPT o un altro assistente di IA per usare le tue note dalla chat. La sezione Caliu con l'IA in Aiuto spiega come fare.",
    "connected": "Connessa il {{date}}",
    "lastUsed": "Ultimo uso: {{date}}",
    "revoke": "Revoca",
    "revokeTitle": "Revoca connessione",
    "revokeHint": "Questo revocherà l'accesso di <strong>{{name}}</strong> al tuo account Caliu ed eliminerà le credenziali utilizzate. Perderà l'accesso immediatamente.",
    "thisApp": "questa app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Scrittura",
    "metadata": "Metadati",
    "words": "Parole",
    "characters": "Caratteri",
    "paragraphs": "Paragrafi",
    "readTime": "Tempo di lettura",
    "minutes": "{{count}} min",
    "tags": "Tag",
    "outgoingLinks": "Link in uscita",
    "backlinks": "Backlink",
    "created": "Creata",
    "modified": "Modificata",
    "noteStatistics": "Statistiche della nota",
    "identifier": "Identificatore"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Struttura",
    "tabHistory": "Cronologia",
    "dates": "Date",
    "noHeadings": "Nessun titolo in questa nota",
    "noBacklinks": "Nessuna nota rimanda qui",
    "noOutgoing": "Questa nota non rimanda a nulla",
    "noAttachments": "Nessun allegato in questa nota",
    "historyOffline": "La cronologia delle versioni richiede una connessione",
    "historyLoadMore": "Carica altro"
  },
  "devices": {
    "title": "Dispositivi",
    "offline": "Sei offline.",
    "offlineHint": "Collegati a Internet per vedere i tuoi dispositivi.",
    "noSessions": "Nessuna sessione attiva trovata.",
    "thisDevice": "Questo dispositivo",
    "lastUsed": "Ultimo utilizzo: {{date}}",
    "created": "Creato: {{date}}",
    "signOutCurrent": "Esci da questo dispositivo",
    "signOut": "Esci",
    "confirmCurrentTitle": "Uscire da questo dispositivo?",
    "confirmRevokeTitle": "Revocare il dispositivo?",
    "confirmCurrentBody": "Verrai disconnesso da Caliu su questo browser e le note saranno rimosse da questo dispositivo. Accedi di nuovo quando vuoi e torneranno dal tuo account.",
    "confirmRevokeBody": "Il dispositivo verrà disconnesso immediatamente. Le modifiche non sincronizzate rimarranno lì finché non accedi di nuovo.",
    "revoke": "Revoca"
  },
  "errorScreen": {
    "title": "Qualcosa è andato storto",
    "defaultMessage": "Si è verificato un errore imprevisto. Prova a ricaricare la pagina."
  },
  "importModal": {
    "title": "Importa note",
    "dropToImport": "Rilascia per importare",
    "dropOrClick": "Rilascia i file o fai clic per cercare",
    "removeFile": "Rimuovi file",
    "keepNote": "Per Google Keep, esporta uno ZIP da Takeout e carica direttamente quell'archivio.",
    "importedCount_one": "Importata <strong>{{count}}</strong> nota",
    "importedCount_other": "Importate <strong>{{count}}</strong> note",
    "fromSource": " da {{source}}",
    "importing": "Importazione…",
    "importN": "Importa {{count}} file",
    "importBtn": "Importa"
  },
  "share": {
    "shareNote": "Condividi nota",
    "publiclySharedAria": "La nota è condivisa pubblicamente",
    "copyLink": "Copia link",
    "revokingLink": "Revoca in corso…",
    "revokeLink": "Revoca link",
    "creatingLink": "Creazione link…",
    "createPublicLink": "Crea link pubblico",
    "shareThisNotePublicly": "Condividi pubblicamente questa nota",
    "thisNoteIsPrivate": "Questa nota è privata.",
    "publiclyShared": "Condivisa pubblicamente",
    "privateNote": "Nota privata"
  },
  "shortcuts": {
    "searchPlaceholder": "Cerca scorciatoie…",
    "pressNew": "Premi la nuova scorciatoia…",
    "resetToDefault": "Ripristina predefinito",
    "noMatches": "Nessuna scorciatoia corrisponde a «<strong>{{query}}</strong>»",
    "navigate": "naviga",
    "edit": "modifica",
    "closeAction": "chiudi",
    "resetAll": "Ripristina tutto"
  },
  "tagEditor": {
    "icon": "Icona",
    "color": "Colore",
    "searchIcons": "Cerca icone",
    "noIcons": "Nessuna icona corrisponde",
    "categories": {
      "essentials": "Essenziali",
      "work": "Lavoro e tecnologia",
      "ideas": "Idee e creatività",
      "life": "Persone e casa",
      "travel": "Viaggi e natura",
      "fun": "Cibo, salute e svago"
    }
  },
  "tagActions": {
    "pin": "Fissa tag",
    "unpin": "Rimuovi fissaggio dal tag",
    "rename": "Rinomina…",
    "renameTitle": "Rinomina tag",
    "renameConfirm": "Rinomina",
    "renameHint": "Il tag viene aggiornato in tutte le note che lo usano, incluse quelle archiviate e nel cestino.",
    "renamed": "Tag rinominato",
    "nameInUse": "Questo nome è già in uso",
    "invalidName": "I nomi dei tag possono contenere solo lettere, numeri, spazi, trattini e trattini bassi",
    "pinFailed": "Impossibile aggiornare il tag",
    "renameFailed": "Impossibile rinominare il tag",
    "editAppearance": "Modifica aspetto"
  },
  "auth": {
    "appName": "Caliu",
    "or": "o",
    "email": "Email",
    "emailPlaceholder": "tu@esempio.com",
    "password": "Password",
    "passwordPlaceholder": "Password",
    "name": "Nome",
    "namePlaceholder": "Il tuo nome",
    "confirmPassword": "Conferma password",
    "newPassword": "Nuova password",
    "confirmNewPassword": "Conferma nuova password",
    "signInSubtitle": "Accedi al tuo account",
    "createAccountSubtitle": "Crea il tuo account",
    "forgotPassword": "Password dimenticata?",
    "signingIn": "Accesso in corso…",
    "signIn": "Accedi",
    "noAccount": "Non hai un account?",
    "signUp": "Registrati",
    "haveAccount": "Hai già un account?",
    "creatingAccount": "Creazione account…",
    "createAccount": "Crea account",
    "googleSignUpAria": "Registrati con Google",
    "signupClosedTitle": "Le registrazioni sono chiuse",
    "signupClosedBody": "Caliu è in beta privata. Iscriviti alla lista d'attesa su caliuapp.com per ottenere l'accesso anticipato.",
    "joinWaitlist": "Iscriviti alla lista d'attesa",
    "forgotTitle": "Reimposta la password",
    "forgotSubtitle": "Inserisci la tua email e ti invieremo un link per reimpostarla.",
    "sendResetLink": "Invia link di reimpostazione",
    "sending": "Invio…",
    "checkYourEmail": "Controlla la tua email",
    "resetLinkSentPrefix": "Se ",
    "resetLinkSentSuffix": " ha un account, abbiamo inviato un link per reimpostare la password. Scade in 1 ora.",
    "backToSignIn": "Torna ad accedere",
    "verifySentPrefix": "Abbiamo inviato un link di verifica a ",
    "verifySentSuffix": ". Cliccaci sopra per attivare il tuo account.",
    "linkExpires10m": "Il link scade tra 10 minuti.",
    "resending": "Reinvio…",
    "resendEmail": "Rinvia email",
    "wrongEmail": "Email sbagliata?",
    "goBack": "Torna indietro",
    "invalidResetLinkTitle": "Link di reimpostazione non valido",
    "invalidResetLinkBody": "Questo link non è valido o è scaduto.",
    "requestNewLink": "Richiedi un nuovo link",
    "setNewPasswordTitle": "Imposta nuova password",
    "setNewPasswordHint": "Scegli una password robusta.",
    "updatingPassword": "Aggiornamento…",
    "updatePassword": "Aggiorna password",
    "localNotesTitle": "Hai delle note su questo dispositivo",
    "localNotesBody_one": "Hai scritto {{count}} nota qui prima di accedere. Cosa vuoi farne?",
    "localNotesBody_other": "Hai scritto {{count}} note qui prima di accedere. Cosa vuoi farne?",
    "localNotesDelete": "Eliminale",
    "localNotesMerge": "Aggiungile al mio account",
    "backToMyNotes": "Torna alle mie note",
    "errorGoogleAuthFailed": "Accesso con Google non riuscito. Riprova.",
    "errorInvalidToken": "Link di verifica non valido. Registrati di nuovo.",
    "errorEmailTaken": "Questa email è già in uso. Accedi.",
    "signInInstead": "Accedi a quell'account",
    "errorIdentityTaken": "Questa identità appartiene già a un altro account Caliu. Accedi a quell'account.",
    "parkedNotesTitle": "Note di un altro account",
    "parkedNotesBody_one": "Accedi a {{email}} per conservarne le note su questo dispositivo. Un altro account cancellerà l'unica nota presente qui, compreso quanto scritto da allora.",
    "parkedNotesBody_other": "Accedi a {{email}} per conservarne le note su questo dispositivo. Un altro account cancellerà tutte le {{count}} note presenti qui, compreso quanto scritto da allora.",
    "parkedNotesBodyNoEmail_one": "Accedi all'account da cui hai effettuato la disconnessione per conservarne le note su questo dispositivo. Un altro account cancellerà l'unica nota presente qui, compreso quanto scritto da allora.",
    "parkedNotesBodyNoEmail_other": "Accedi all'account da cui hai effettuato la disconnessione per conservarne le note su questo dispositivo. Un altro account cancellerà tutte le {{count}} note presenti qui, compreso quanto scritto da allora.",
    "parkedNotesContinue": "Continua"
  },
  "connectors": {
    "wantsAccess": "vuole accedere a Caliu",
    "couldntLoad": "Impossibile caricare questa richiesta",
    "authorize": "Autorizza",
    "keepHappeningHint": "Se il problema persiste, rimuovi il connettore dal tuo client MCP e aggiungilo di nuovo.",
    "backToCaliu": "Torna a Caliu",
    "askingPermissionPrefix": "sta chiedendo il permesso di leggere e modificare le tue note ed etichette tramite il server MCP di Caliu.",
    "signedInAs": "Hai effettuato l'accesso come {{name}}.",
    "permissions": "Permessi",
    "deny": "Nega",
    "allow": "Consenti"
  },
  "editorTypography": {
    "fontSize": "Dimensione carattere",
    "lineHeight": "Altezza riga",
    "paragraphSpacing": "Spaziatura paragrafo"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Maiusc"
  },
  "floatingMenu": {
    "undo": "Annulla",
    "redo": "Ripristina",
    "taskList": "Elenco attività",
    "bulletList": "Elenco puntato",
    "orderedList": "Elenco numerato",
    "blockQuote": "Citazione",
    "separator": "Separatore",
    "insertTag": "Inserisci etichetta",
    "highlight": "Evidenzia",
    "math": "Formula",
    "removeHighlight": "Rimuovi evidenziazione",
    "inlineCode": "Codice in linea",
    "codeBlock": "Blocco di codice",
    "insertTable": "Inserisci tabella",
    "insertImage": "Inserisci immagine",
    "hideStyleBar": "Nascondi barra di stile",
    "attachFile": "Allega file",
    "photoLibrary": "Foto",
    "camera": "Fotocamera",
    "fromFile": "Da file"
  },
  "imageDialog": {
    "title": "Inserisci immagine",
    "tabUpload": "File",
    "tabUrl": "URL",
    "urlLabel": "URL immagine",
    "urlPlaceholder": "https://esempio.com/immagine.jpg",
    "altLabel": "Testo alternativo",
    "altPlaceholder": "Descrivi l'immagine…",
    "previewAlt": "anteprima",
    "changeImage": "Cambia immagine",
    "dropToInsert": "Rilascia per inserire",
    "dropOrClick": "Rilascia un'immagine o fai clic per cercare",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Inserisci immagine"
  },
  "linkDialog": {
    "editTitle": "Modifica link",
    "insertTitle": "Inserisci link",
    "textLabel": "Testo",
    "textPlaceholder": "Testo del link",
    "urlPlaceholder": "https://esempio.com",
    "removeLink": "Rimuovi link",
    "openLink": "Apri link",
    "editLink": "Modifica link"
  },
  "noteEditor": {
    "notFound": "Nota non trovata.",
    "inTrashBanner": "Questa nota è nel cestino. Ripristinala per modificarla.",
    "restore": "Ripristina",
    "noContent": "Questa nota non ha contenuto."
  },
  "noteHeader": {
    "noteInfo": "Info nota"
  },
  "table": {
    "deleteRow": "Elimina riga",
    "deleteTable": "Elimina tabella",
    "addRow": "Aggiungi riga",
    "addRowAbove": "Aggiungi riga sopra",
    "addColumn": "Aggiungi colonna",
    "addColumnBefore": "Aggiungi colonna prima",
    "moveRowUp": "Sposta riga su",
    "moveRowDown": "Sposta riga giù",
    "moveColumnLeft": "Sposta colonna a sinistra",
    "moveColumnRight": "Sposta colonna a destra",
    "deleteColumn": "Elimina colonna",
    "actions": "Azioni tabella"
  },
  "syncIndicator": {
    "synced": "Sincronizzato",
    "pending_one": "{{count}} sincronizzazione in sospeso",
    "pending_other": "{{count}} sincronizzazioni in sospeso",
    "offline": "Offline",
    "offlinePending_one": "Offline · {{count}} in sospeso",
    "offlinePending_other": "Offline · {{count}} in sospeso",
    "syncing": "Sincronizzazione...",
    "conflict_one": "{{count}} conflitto",
    "conflict_other": "{{count}} conflitti",
    "error": "Errore di sincronizzazione",
    "syncedTooltip": "Tutte le modifiche salvate",
    "pendingTooltip_one": "{{count}} modifica in attesa di sincronizzazione",
    "pendingTooltip_other": "{{count}} modifiche in attesa di sincronizzazione",
    "offlineTooltip": "Offline: le modifiche verranno sincronizzate alla riconnessione",
    "offlinePendingTooltip_one": "Offline: {{count}} modifica verrà sincronizzata alla riconnessione",
    "offlinePendingTooltip_other": "Offline: {{count}} modifiche verranno sincronizzate alla riconnessione",
    "syncingTooltip": "Sincronizzazione...",
    "syncingPendingTooltip_one": "Sincronizzazione di {{count}} modifica in sospeso...",
    "syncingPendingTooltip_other": "Sincronizzazione di {{count}} modifiche in sospeso...",
    "conflictTooltip_one": "{{count}} nota ha modifiche in conflitto. Fai clic per risolvere.",
    "conflictTooltip_other": "{{count}} note hanno modifiche in conflitto. Fai clic per risolvere.",
    "errorTooltip": "Sincronizzazione non riuscita. Verrà riprovata automaticamente.",
    "conflictsTitle": "Risolvi i conflitti",
    "local": "Su questo dispositivo",
    "localTooltip": "Solo su questo dispositivo. Accedi per sincronizzare."
  },
  "image": {
    "download": "Scarica immagine",
    "replace": "Sostituisci immagine",
    "remove": "Rimuovi immagine"
  },
  "sharePage": {
    "goToCaliu": "Vai a Caliu",
    "noteNotFoundTitle": "Nota non trovata",
    "somethingWentWrong": "Qualcosa è andato storto",
    "lastUpdated": "Ultimo aggiornamento: {{date}}",
    "tagline": "Un'app di note per chi pensa",
    "subtagline": "Scrivi in markdown. Sincronizza ovunque. Pensa con chiarezza.",
    "startWriting": "Inizia a scrivere",
    "signIn": "Accedi",
    "openInCaliu": "Apri in Caliu",
    "adding": "Aggiunta in corso…",
    "addToSharedList": "Aggiungi alla mia lista condivisa",
    "notFoundSubtitle": "Questo link condiviso potrebbe essere scaduto o essere stato revocato.",
    "errorSubtitle": "Impossibile caricare questa nota. Riprova."
  },
  "sharedView": {
    "loading": "Caricamento nota condivisa…",
    "sharedWithYou": "Condivisa con te",
    "viewRaw": "Mostra Markdown grezzo",
    "viewRendered": "Mostra nota formattata",
    "copyMarkdown": "Copia Markdown",
    "markdownCopied": "Markdown copiato",
    "copyFailed": "Copia non riuscita",
    "notLoadedYet": "Questa nota non è ancora stata caricata",
    "linkCopied": "Link copiato",
    "actions": "Azioni della nota"
  },
  "sharedWithMe": {
    "title": "Condivise con me",
    "removeFromList": "Rimuovi dalla lista",
    "empty": "Nessuna nota condivisa",
    "emptyHint": "Apri un link condiviso di Caliu da un amico per aggiungerlo qui. Le note condivise si sincronizzano su tutti i tuoi dispositivi."
  },
  "trashView": {
    "empty": "Il cestino è vuoto",
    "emptyHint": "Le note eliminate appariranno qui",
    "retention": "Le note nel cestino vengono eliminate definitivamente dopo 30 giorni",
    "trash": "Cestino"
  },
  "fileAttachment": {
    "download": "Scarica file",
    "remove": "Rimuovi file"
  },
  "archiveView": {
    "archive": "Archiviate",
    "empty": "L'archivio è vuoto",
    "emptyHint": "Le note archiviate appariranno qui",
    "archivedOn": "Archiviata il {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, senza limiti.",
    "features": [
      "Note illimitate",
      "Cronologia delle versioni delle note",
      "Esporta in PDF, HTML, RTF, ePub + in blocco",
      "Tutti i temi, i font e le icone dell'app",
      "Sostiene lo sviluppo di Caliu"
    ],
    "perMonth": "{{price}} al mese",
    "perWeek": "{{price}} a settimana",
    "oneTime": "{{price}} una tantum",
    "perYear": "{{price}} all'anno",
    "or": "o",
    "signInToSubscribe": "Accedi per abbonarti",
    "accountRequired": "Caliu Pro è collegato al tuo account, quindi si sblocca su tutti i tuoi dispositivi.",
    "plansUnavailable": "Non siamo riusciti a caricare i piani. Controlla la connessione e riprova.",
    "yearly": "Annuale",
    "monthly": "Mensile",
    "continue": "Continua",
    "bestValue": "Miglior prezzo",
    "autoRenew": "{{amount}}. Si rinnova automaticamente fino all'annullamento. Disdici quando vuoi.",
    "freeTrial": "Gratis per {{count}} giorni",
    "billedSubtitle": "Gratis per {{count}} giorni, poi {{amount}}. Annulla quando vuoi.",
    "startTrial": "Inizia la prova gratuita",
    "upgradeSubtitle": "Cronologia delle versioni, tutti i temi e i font, esportazione e altro ancora.",
    "upgradeNow": "Aggiorna ora",
    "thanks": "Grazie per supportare Caliu!",
    "renewsOn": "Si rinnova il {{date}}",
    "endsOn": "Termina il {{date}}",
    "lifetime": "Accesso a vita",
    "lifetimePlan": "A vita",
    "oneTimeNoRenewal": "Pagamento unico",
    "launchPrice": "Prezzo di lancio. In seguito salirà a {{price}}.",
    "buy": "Acquista",
    "oneTimeDisclosure": "{{amount}}. Pagamento unico, nessun rinnovo.",
    "thanksMessage": "Il tuo supporto mantiene Caliu indipendente e privato.",
    "manageSubscription": "Gestisci abbonamento",
    "contactUs": "Domande? Scrivici",
    "grandfatheredNote": "Come primo sostenitore, Caliu Pro è tuo a vita. Niente da rinnovare.",
    "webFootnote": "L'esportazione in PDF non è ancora disponibile sul web.",
    "active": "Attivo"
  },
  "find": {
    "placeholder": "Cerca nella nota",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Nessun risultato",
    "next": "Corrispondenza successiva",
    "previous": "Corrispondenza precedente",
    "close": "Chiudi"
  },
  "conflicts": {
    "description": "Questa nota è stata modificata su un altro dispositivo. Conserva una versione.",
    "yours": "La tua versione",
    "theirs": "La loro versione",
    "step": "{{current}} di {{total}}",
    "keepYours": "Mantieni la tua",
    "keepTheirs": "Mantieni la loro",
    "serverError": "Impossibile caricare l'altra versione.",
    "done": "Tutti i conflitti risolti.",
    "previous": "Conflitto precedente",
    "next": "Conflitto successivo",
    "copyOf": "Copia di {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Ti diamo il benvenuto in Caliu",
    "welcomeSubtitle": "Uno spazio tranquillo dove i tuoi pensieri possono vivere e respirare.",
    "getStarted": "Inizia",
    "magicTitle": "Guarda le tue parole prendere forma",
    "magicSubtitle": "Tu scrivi testo semplice. Caliu lo trasforma in struttura: attività, evidenziazioni ed etichette che si archiviano da sole.",
    "magicLearnMore": "Impara le basi di Markdown",
    "replay": "Ripeti",
    "demoTitle": "Estate in riva al mare",
    "demoBody": "Organizzare una **settimana lenta** in un piccolo paese.",
    "demoTask": "Prenotare la casetta",
    "demoHighlight": "Nuotare ==prima== di colazione",
    "demoTags": "#estate #progetti",
    "intentTitle": "Cosa porterai qui?",
    "intentSubtitle": "Scegline alcuni. La tua prima nota e le tue etichette ti aspetteranno, già tue.",
    "themeTitle": "Scegli la tua luce",
    "themeSubtitle": "Temi per accompagnare il tono della tua scrittura.",
    "proTitle": "Inizia con tutto",
    "proSubtitle": "Inizia con tutto dal primo giorno. Provalo gratis, tienilo solo se si guadagna il suo posto.",
    "proTrust": "Niente pubblicità. Niente trucchi. Annulla quando vuoi.",
    "tryProFree": "Prova Pro gratuitamente",
    "continueFree": "Continua con il piano gratuito",
    "allSetTitle": "Tutto pronto",
    "allSetSubtitle": "Benvenuto in Caliu. Rendilo tuo.",
    "startWriting": "Inizia a scrivere",
    "firstNoteTitle": "Dove tutto comincia",
    "firstNoteBody": "Questa è la mia prima nota. Vive su questo dispositivo, funziona offline e mi segue ovunque.",
    "firstNoteTask": "Annotare un pensiero che vale la pena conservare",
    "next": "Avanti",
    "skip": "Salta",
    "back": "Indietro",
    "intents": {
      "journal": "Diario",
      "ideas": "Idee",
      "work": "Lavoro",
      "study": "Studio",
      "reading": "Letture",
      "plans": "Progetti"
    },
    "signInCta": "Accedi o crea un account",
    "continueWithoutAccount": "Continua senza account",
    "backupTitle": "Dove vivono le tue note",
    "backupSubtitle": "Iniziano su questo dispositivo. Con un account si sincronizzano, così una copia al sicuro arriva su tutti i tuoi dispositivi.",
    "syncOffTitle": "La sincronizzazione è disattivata",
    "syncOffBody": "Accedi per sincronizzare le tue note su tutti i tuoi dispositivi.",
    "backupSignedIn": "Le tue note vengono sincronizzate in modo sicuro mentre scrivi.",
    "backupStageDevice": "Questo dispositivo",
    "backupStageSafe": "Sincronizzate",
    "backupStageEverywhere": "Tutti i tuoi dispositivi",
    "freeNotes": "{{limit}} note gratis, senza account, per sempre. Pro le rende illimitate."
  },
  "backup": {
    "evictionNotice": "Per ora le note vivono solo in questo browser. I browser possono cancellare i dati del sito quando lo spazio scarseggia.",
    "dismiss": "Ignora",
    "signIn": "Accedi"
  },
  "gate": {
    "share": "Accedi per condividere le note.",
    "history": "Accedi per conservare la cronologia delle versioni.",
    "import": "Accedi per importare le note."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Sorgente LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} note su {{limit}}",
    "paywallTitle": "Hai raggiunto le {{limit}} note gratuite",
    "paywallBody": "Modifica, ricerca e sincronizzazione continuano a funzionare. Sposta una nota nel cestino per liberare un posto, oppure passa a illimitato con Caliu Pro: mensile, annuale o con un acquisto unico a vita.",
    "importCapped": "Sono stati importati solo {{count}} file su {{total}}: il piano gratuito consente {{limit}} note."
  },
  "appUpdate": {
    "available": "È disponibile una nuova versione di Caliu."
  },
  "settings": {
    "title": "Impostazioni",
    "account": "Account",
    "writing": "Scrittura",
    "keyboardShortcuts": "Abbreviazioni da tastiera",
    "editor": "Editor",
    "yourNotes": "Le tue note",
    "about": "Informazioni",
    "noAccount": "Nessun account",
    "sendFeedback": "Invia feedback",
    "signInOrCreate": "Accedi o crea un account",
    "notesComeWithYou": "Le note su questo dispositivo vengono con te.",
    "notSyncing": "Non sincronizzato",
    "signInToSync": "Accedi per sincronizzare le tue note.",
    "sync": "Sincronizzazione",
    "security": "Sicurezza",
    "communications": "Comunicazioni",
    "newsletter": "Newsletter di Caliu",
    "newsletterFooter": "Una breve email ogni tanto sulle nuove versioni e su cosa sta arrivando in Caliu.",
    "newsletterError": "Impossibile aggiornare la newsletter. Riprova.",
    "appearance": "Aspetto",
    "themes": "Temi",
    "sizing": "Dimensione",
    "systemDefault": "Predefinito di sistema",
    "separateThemes": "Temi diversi per chiaro e scuro",
    "maxWidth": "Larghezza massima",
    "maxWidthHint": "Centra il testo in una colonna leggibile sugli schermi larghi",
    "markdownReturn": "Invio in stile Markdown",
    "markdownReturnHint": "Invio interrompe la riga. Premi Invio due volte per un nuovo paragrafo",
    "newNoteStart": "Le nuove note iniziano con",
    "newNoteStartH1": "Titolo 1",
    "newNoteStartH2": "Titolo 2",
    "newNoteStartH3": "Titolo 3",
    "newNoteStartH4": "Titolo 4",
    "newNoteStartDate": "Data",
    "newNoteStartDateIso": "Data (ISO 8601)",
    "newNoteStartDateTime": "Data e ora",
    "newNoteStartDateTimeIso": "Data e ora (ISO 8601)",
    "newNoteStartEmpty": "Vuota",
    "newNoteStartHint": "Si applica alle note che crei nell'app.",
    "collapsibleSections": "Sezioni comprimibili",
    "collapsibleSectionsHint": "Consente di comprimere un titolo e il suo contenuto dietro una freccia",
    "experimental": "Sperimentale",
    "general": "Generali"
  },
  "toolbar": {
    "toggleSidebar": "Mostra/Nascondi barra laterale",
    "toggleInspector": "Mostra/nascondi ispettore",
    "searchNotes": "Cerca note",
    "newNote": "Nuova nota",
    "findInNote": "Trova nella nota",
    "showToolbar": "Mostra barra strumenti",
    "hideToolbar": "Nascondi barra strumenti",
    "moreNoteActions": "Altre azioni nota",
    "undo": "Annulla",
    "redo": "Ripeti",
    "zenMode": "Modalità Zen",
    "sourceMode": "Modalità sorgente",
    "richEditor": "Editor formattato",
    "sortBy": "Ordina per",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "heading": "Titolo",
    "list": "Elenco",
    "link": "Collegamento",
    "insert": "Inserisci",
    "more": "Altro",
    "strikethrough": "Barrato",
    "table": "Tabella",
    "horizontalRule": "Linea orizzontale",
    "codeBlock": "Blocco di codice",
    "inlineCode": "Codice in linea",
    "blockQuote": "Citazione",
    "math": "Formula",
    "highlight": "Evidenziazione",
    "bulletList": "Elenco puntato",
    "orderedList": "Elenco numerato",
    "photoLibrary": "Libreria foto",
    "camera": "Fotocamera",
    "files": "File",
    "yellow": "Giallo",
    "green": "Verde",
    "blue": "Blu",
    "pink": "Rosa",
    "purple": "Viola",
    "heading1": "Titolo 1",
    "heading2": "Titolo 2",
    "heading3": "Titolo 3",
    "heading4": "Titolo 4",
    "heading5": "Titolo 5",
    "heading6": "Titolo 6",
    "removeHighlight": "Rimuovi evidenziazione"
  },
  "whatsNew": {
    "title": "Novità",
    "tagIconsTitle": "Icone disegnate per Caliu",
    "tagIconsBody": "Tutte le icone dell'app sono nuove e create per Caliu. Dai a ogni tag la sua icona e cercale nella tua lingua.",
    "newNoteStartTitle": "Inizia le note a modo tuo",
    "newNoteStartBody": "Una nuova nota può aprirsi con un titolo, la data di oggi, data e ora, o una pagina vuota. Sceglilo in Impostazioni, sotto Editor.",
    "typographyTitle": "Tipografia, al punto esatto",
    "typographyBody": "Scegli la dimensione esatta del testo, l'altezza della riga e la spaziatura dei paragrafi delle tue note, in Impostazioni, sotto Tipografia.",
    "typographySample": "Ogni nota segue la dimensione, l'altezza della riga e la spaziatura che imposti, punto per punto.",
    "sampleMorningPages": "Pagine del mattino",
    "newsletterTitle": "Arriva la newsletter di Caliu",
    "newsletterBody": "D'ora in poi, una breve email ti racconta le novità di ogni versione, nella tua lingua. Attivala se ti va. Puoi cambiare idea quando vuoi nelle Impostazioni."
  },
  "sharing": {
    "inviteByEmail": "Invita via email",
    "invite": "Invita",
    "roleOwner": "Proprietario",
    "roleEditor": "Può modificare",
    "roleViewer": "Può visualizzare",
    "generalAccess": "Accesso generale",
    "shareWithLink": "Condividi con un link",
    "accessRestricted": "Solo le persone invitate",
    "accessView": "Chiunque abbia il link può visualizzare",
    "accessEdit": "Chiunque abbia il link può modificare",
    "remove": "Rimuovi",
    "leave": "Esci",
    "leaveNote": "Esci dalla nota",
    "leaveConfirmTitle": "Uscire da questa nota?",
    "leaveConfirmBody": "Scomparirà dai tuoi elenchi su tutti i dispositivi. Il proprietario può invitarti di nuovo.",
    "leaveSelectedTitle": "Uscire dalle note condivise?",
    "leaveSelectedBody_one": "Uscirai da {{count}} nota condivisa con te. Le tue note andranno nel cestino.",
    "leaveSelectedBody_other": "Uscirai da {{count}} note condivise con te. Le tue note andranno nel cestino.",
    "sharedBy": "Condivisa da {{name}}",
    "sharedList": "Condivise",
    "viewOnly": "Sola lettura",
    "accessNowEditor": "Ora puoi modificare questa nota.",
    "accessNowViewer": "Ora puoi solo visualizzare questa nota.",
    "accessRemoved": "Non hai più accesso a questa nota.",
    "unsentSavedAsCopy": "Le modifiche non inviate sono state salvate in una copia.",
    "privateNote": "Nota privata",
    "memberLimit": "Una nota può essere condivisa con al massimo 50 persone.",
    "rateLimit": "Troppi inviti. Riprova più tardi.",
    "inviteFailed": "Impossibile inviare gli inviti. Riprova.",
    "invalidEmail": "Inserisci un indirizzo email valido.",
    "onlineOnly": "Connettiti a internet per gestire la condivisione.",
    "you": "Tu",
    "ownerOnly": "Solo il proprietario può cambiare chi ha accesso.",
    "unavailable": "La condivisione non è disponibile al momento. Riprova più tardi.",
    "updateFailed": "Impossibile aggiornare la condivisione. Riprova.",
    "inviteInvalid": "Questo invito non è più valido.",
    "copyLink": "Copia link",
    "invited": "Invitato",
    "copied": "Copiato",
    "accessRestrictedHint": "Solo le persone che inviti possono aprirla.",
    "onlyYouHint": "Solo tu puoi aprirla.",
    "accessViewHint": "Chiunque abbia il link può leggerla, senza account.",
    "accessEditHint": "Chiunque abbia il link può modificarla.",
    "roleBelowLink": "Chiunque abbia il link può modificare, quindi anche le persone che inviti possono modificare.",
    "inviteAs": "Invita come",
    "revokeInvite": "Revoca invito",
    "statusPeople_one": "{{count}} persona",
    "statusPeople_other": "{{count}} persone",
    "publicLink": "Link pubblico",
    "statusFrom": "Da {{name}}",
    "removeConfirmTitle": "Rimuovere {{name}}?",
    "removeConfirmBody": "Non avrà più accesso a questa nota.",
    "revokeConfirmTitle": "Revocare l'invito a {{name}}?",
    "revokeConfirmBody": "Il link dell'invito smetterà di funzionare.",
    "peopleWithAccess": "Persone con accesso",
    "addPeoplePlaceholder": "Aggiungi persone via email",
    "invitePro": "Invitare persone fa parte di Caliu Pro.",
    "inviteKeepsAccess": "Le persone invitate mantengono l'accesso se disattivi il link.",
    "youSuffix": "(tu)"
  },
  "noAccess": {
    "title": "Non hai accesso a questa nota",
    "linkBody": "Il proprietario non l'ha condivisa con te. Chiedigli di invitarti o di attivare il link.",
    "signedOutBody": "Accedi con l'account con cui è stata condivisa.",
    "inviteTitle": "Questo invito non è più valido",
    "inviteBody": "Chiedine uno nuovo alla persona che ti ha invitato.",
    "removedTitle": "Non hai più accesso a questa nota",
    "removedBody": "Il proprietario ti ha rimosso.",
    "removedCopyBody": "Il proprietario ti ha rimosso. Le modifiche non inviate sono state salvate come copia nelle tue note.",
    "backToNotes": "Torna alle note",
    "signIn": "Accedi"
  }
}
